module.exports = __webpack_public_path__ + "assets/error-b41796.svg";